<script>
  export let text = "define text";
  export let color = "#1C1C20";
  export let textColor = "#ffffff";
  export let warning = false;
</script>

<div
  class="wrapper"
  style="background-color: {color}; color: {textColor};"
  class:warning={warning === true}
>
  <div class="container" class:format_warning={warning === true}>
    {#if warning}
      <div class="img_container">
        <img src="/img/assistant/icons/warning.svg" alt="warning" />
      </div>
    {/if}
    <div>{text}</div>
  </div>
</div>

<style>
  .wrapper {
    display: flex;
    height: 2rem;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
    border-radius: 1rem;
    color: white;
  }

  .container {
    display: flex;
  }

  .img_container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    height: 1rem;
    max-height: 1rem;
  }

  .warning {
    background-color: red !important;
    color: white !important;
  }

  .format_warning {
    gap: 0.5rem !important;
  }
</style>
